export default (startTime, endTime, date) => {
  if (!startTime || !endTime || !date) {
    return true;
  }

  return false
}